import React, { Component } from 'react';
import { Radio } from 'antd';
import './AirRadioGroup.css';
export default class AirRadioGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.hasOwnProperty('value') ? this.props.value : null
    };
  }

  onChange = (e) => {
    this.setState({
      value: e.target.value,
    });
    this.props.onChange(e);
  };

  render() {

    const childrenRadio = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        checked: child.props.value === this.state.value
      });
    });

    return (
      <div className="AirRadioGroup">
        <Radio.Group onChange={this.onChange}>
          {/*{this.props.children}*/}
          {childrenRadio}
        </Radio.Group>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirRadioGroup/AirRadioGroup.js